export const appointmentCopy = {
    dayPicker: {
        title: "Selecteer voorkeursdatum",
        noticePrefix: "Let op:",
        notice: "je geeft hiermee een voorkeursdatum op. De vestiging neemt nog contact met je op om de afspraak te bevestigen of om een andere datum met je te plannen.",
    },
    establishments: {
        title: "Selecteer een vestiging",
        sortFast: "Ik wil zo snel mogelijk een afspraak",
    },
} as const;
